export default __webpack_public_path__ + "static/media/kwadrat_wroclaw.d5e5330b.jpg";